module.exports = __webpack_public_path__ + "assets/img/kv-98d69910.jpg";